import SvgIcon from "@/components/base/SvgIcon"

/** @type import('vue').PluginObject<never> */
export const BaseComponentsPlugin = {
  install(Vue) {
    Vue.component("SvgIcon", SvgIcon)
  }
}
